import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResponseData } from 'src/app/Model/Base/Response';
import { CountryModel } from 'src/app/Model/Country.model';
import { DocumentTypeModel } from 'src/app/Model/DocumentType.model';
import { PartnersModel } from 'src/app/Model/Partners.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { RolesArdModel } from 'src/app/Model/RolesArd.model';
import { ChargeCatalog, SignatureUsersModel } from 'src/app/Model/SignatureUsers.model';
import { UpdateStatusProcessModel } from 'src/app/Model/UpdateStatusProcess.model';
import { VRequestStatusProcessModel } from 'src/app/Model/VRequestStatusProcess.Model';
import { ParametersService } from 'src/app/Services/Parameters/parameters.service';
import { crmGeoService } from 'src/app/Services/crm-geo-service/crm-geo-service.service';
import { RequestService } from 'src/app/Services/request/request.service';
import { CustomValidators } from 'src/app/Util/CustomValidators';
import { MatTableHelpers } from 'src/app/Util/MatTableHelpers';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-agency-signatures',
  templateUrl: './agency-signatures.component.html',
  styleUrls: ['./agency-signatures.component.css']
})

export class AgencySignaturesComponent {
  chargeCatalog: ChargeCatalog = new ChargeCatalog();
  todayDate: Date = new Date();
  public isMobile: boolean = false;
  @Input() request: RequestModel;
  @Input() lstDocumentTypes: DocumentTypeModel[];
  @Input() lstRolesArd: RolesArdModel[];
  @Output() newRequestEvent = new EventEmitter<number>();
  @Input() lstCountries: CountryModel[];
  @Input() accessRequest: boolean = false;
  allowEdit: boolean;
  @Input() lstStatuses: VRequestStatusProcessModel[];
  maxSignaturesIata: number = 10;
  maxSignaturesNoIata: number = 3;
  displayedColumns: string[] = ['FirstName', 'MiddleName', 'FirstSurname', 'SecondSurname', 'Role', 'CompanyName', 'Charge', 'BirthDate', 'actions'];
  dataSource: MatTableDataSource<SignatureUsersModel>;
  extCountryBool: boolean = false;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @Output() nextEvent = new EventEmitter();
  @ViewChild('popUp', { static: false })
  popUp: ElementRef;
  nextStep() {
    this.nextEvent.emit();
  }
  @Output() prevEvent = new EventEmitter();
  prevStep() {
    this.prevEvent.emit();
  }
  constructor(
    public dialog: MatDialog,
    private readonly spinner: NgxSpinnerService,
    private readonly translate: TranslateService,
    private readonly requestService: RequestService,
    private readonly parametersService: ParametersService
  ) { }

  async ngAfterViewInit() {
    this.spinner.show()
    let parameters = await this.parametersService.getParameters();

    this.maxSignaturesIata = + parameters?.find(x => x.Id == environment.request.maxSignaturesIataParameter)?.Value
    this.maxSignaturesNoIata = + parameters?.find(x => x.Id == environment.request.maxSignaturesNoIataParameter)?.Value
    this.spinner.hide()
  }
  ngOnChanges() {
    this.allowEdit = this.lstStatuses != null && this.lstStatuses.some(x => x.IdComponent == 8)

    if (this.paginator != null)
      this.paginator._intl.itemsPerPageLabel = this.translate.instant('Request.Label.Pages');
    this.dataSource = new MatTableDataSource(this.request.SignatureUsers);
    this.dataSource.filteredData.forEach(element => {
      element['Charge'] = this.chargeCatalog.lstChargesArd.find(charge => charge.Name == element['Charge']).Label;
    })
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (data, sortHeaderId: string) => {
      return MatTableHelpers.getPropertyByPath(data, sortHeaderId);
    };
  }
  async updateStatusProcess() {
    this.spinner.show();
    let update = new UpdateStatusProcessModel();
    update.IdMenu = 8;
    update.IdRequest = this.request.Id;
    let res: ResponseData;
    await this.requestService.postStatusCorrection(update).then(resp => {
      res = resp;
    })
    this.spinner.hide();
    if (res.head.status.toLowerCase() == 'true') {
      await Swal.fire({
        icon: 'success',
        text: this.translate.instant('Request.Messages.Success'),
        showConfirmButton: false,
        timer: 2000
      })
      if (this.request.IdFlow != 5 && this.request.IdFlow != 4)
        this.newRequestEvent.emit(this.request.Id)
    }
    else {
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      }
      )
    }
  }
  async onSubmit() {
    await Swal.fire({
      html: this.popUp.nativeElement,
      width: 300,
      showCloseButton: true,
      showConfirmButton: false,

    }).then(res => {
      if (this.request.IdFlow != 6 && this.request.IdFlow != 7)
        this.nextStep();
    })
  }

  async newSignature() {
    if ((this.request.ConnectionType == environment.request.iataConnectionType && this.request.SignatureUsers.length == this.maxSignaturesIata)
      || (this.request.ConnectionType == environment.request.noIataConnectionType && this.request.SignatureUsers.length == this.maxSignaturesNoIata)) {
      await Swal.fire({
        title: this.translate.instant('Request.Messages.MaxUsersTitle'),
        text: this.translate.instant('Request.Messages.MaxUsers'),
        showDenyButton: false,
        showCancelButton: false,
        denyButtonText: this.translate.instant('Cancelar'),
        cancelButtonText: this.translate.instant('Cancelar')
      })
      return
    }
    let datamodal = new DataModal();
    datamodal.Request = this.request;
    datamodal.DocumentTypes = this.lstDocumentTypes;
    datamodal.RolesArd = this.lstRolesArd;
    datamodal.Countries = this.lstCountries
    const dialogRef = this.dialog.open(AgencySignaturesDialogComponent, { width: '600px', data: datamodal });
    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this.newRequestEvent.emit(result);
      }
    });
  }
  async updateSignature(signature: SignatureUsersModel) {
    let datamodal = new DataModal();
    datamodal.Signature = signature;
    datamodal.Request = this.request;
    datamodal.DocumentTypes = this.lstDocumentTypes;
    datamodal.RolesArd = this.lstRolesArd;
    datamodal.Countries = this.lstCountries
    const dialogRef = this.dialog.open(AgencySignaturesDialogComponent, { width: '600px', data: datamodal });
    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this.newRequestEvent.emit(result);
      }
    });
  }
  async removePartner(partner: PartnersModel): Promise<void> {

    let newRequest: RequestModel = Object.assign({}, this.request);
    await Swal.fire({
      title: this.translate.instant('Request.Messages.DeleteUserTitle'),
      text: this.translate.instant('Request.Messages.DeleteUserBody'),
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.translate.instant('Request.Label.Yes'),
      denyButtonText: this.translate.instant('Request.Label.Cancel'),
      cancelButtonText: this.translate.instant('Request.Label.Cancel')
    }).then(async (result) => {
      this.spinner.show()

      if (result.isConfirmed) {
        newRequest.Partners.forEach((item, index) => {
          if (item.Id === partner.Id) newRequest.Partners.splice(index, 1);
        });
        let res: ResponseData;
        await this.requestService.postRequest(newRequest).then(resp => {
          res = resp;
        })
        this.spinner.hide()
        if (res.head.status.toLowerCase() == 'true') {
          this.newRequestEvent.emit(this.request.Id);
          Swal.fire(this.translate.instant('Request.Messages.Success'), '', 'success');
        }
        else {
          await Swal.fire({
            title: 'Error!',
            text: this.translate.instant('Request.Messages.ErrorSaving'),
            icon: 'error'
          })
        }
      }
    })
  }
  async removeSignature(signature: SignatureUsersModel): Promise<void> {

    await Swal.fire({
      title: this.translate.instant('Request.Messages.DeleteUserTitle'),
      text: this.translate.instant('Request.Messages.DeleteUserBody'),
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.translate.instant('Request.Label.Yes'),
      denyButtonText: this.translate.instant('Request.Label.Cancel'),
      cancelButtonText: this.translate.instant('Request.Label.Cancel')
    }).then(async (result) => {
      this.spinner.show()

      if (result.isConfirmed) {
        let res: ResponseData;
        await this.requestService.deleteSignatureUser(signature).then(resp => {
          res = resp;
        })
        this.spinner.hide()
        if (res.head.status.toLowerCase() == 'true') {
          this.newRequestEvent.emit(this.request.Id);
          Swal.fire(this.translate.instant('Request.Messages.Success'), '', 'success');
        }
        else {
          await Swal.fire({
            title: 'Error!',
            text: this.translate.instant('Request.Messages.ErrorSaving'),
            icon: 'error'
          })
        }
      }
      else
        this.spinner.hide()
    })
  }
}
export class DataModal {
  public Request: RequestModel;
  public Signature: SignatureUsersModel;
  DocumentTypes: DocumentTypeModel[];
  Countries: CountryModel[];
  RolesArd: RolesArdModel[];
}
@Component({
  selector: 'agency-signatures-dialog',
  templateUrl: './agency-signatures-dialog.component.html',
  styleUrls: ['./agency-signatures.component.css']
})
export class AgencySignaturesDialogComponent implements OnInit {
  chargeCatalog : ChargeCatalog = new ChargeCatalog();
  lstChargesArd = this.chargeCatalog.lstChargesArd;
  todayDate: Date = new Date();
  lstDocumentTypes: DocumentTypeModel[];
  lstRolesArd: RolesArdModel[];
  allowEdit:boolean
  public isMobile: boolean = false;
  extCountryBool: boolean = false;
  form = new FormGroup({
    firstName: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.AmpersandValidator(),
      CustomValidators.NoWhiteEspacesAllowedValidator(),
      Validators.maxLength(100),]),
    middleName: new FormControl('',
      [
        CustomValidators.AmpersandEmptyValidator(),
        CustomValidators.NoWhiteEspacesAllowedValidator(),
        Validators.maxLength(100),]),
    firstSurname: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.AmpersandValidator(),
      CustomValidators.NoWhiteEspacesAllowedValidator(),
      Validators.maxLength(100),]),
    secondSurname: new FormControl('',
      [
        CustomValidators.AmpersandEmptyValidator(),
        CustomValidators.NoWhiteEspacesAllowedValidator(),
        Validators.maxLength(100),]),
    nationality: new FormControl('', [Validators.required]),
    documentType: new FormControl('', [Validators.required]),
    documentTypeExt: new FormControl('', [
    ]),
    documentNumber: new FormControl('',
      [Validators.required,
      Validators.maxLength(30),
      CustomValidators.lettersOnlySiglaValidator(),
      CustomValidators.NumbersNoRepeatedValidator(),
      CustomValidators.emptyTextValidator()]),
    documentNumberExt: new FormControl('',
      [
        Validators.maxLength(30),]),
    phone: new FormControl('',
      [Validators.required,
      Validators.maxLength(30),
      CustomValidators.numbersOnlyValidator()]),
    email: new FormControl('',
      [Validators.required,
      Validators.maxLength(100),
      CustomValidators.emailValidator(),]),
    role: new FormControl('', [Validators.required]),
    companyname: new FormControl('',
      [Validators.required,
      Validators.maxLength(100),
      CustomValidators.emptyTextValidator()]),
    charge: new FormControl('', [Validators.required]),
    birthDate: new FormControl('', [Validators.required]
    ),
  });

  get firstName() { return this.form.get('firstName'); }
  get middleName() { return this.form.get('middleName'); }
  get firstSurname() { return this.form.get('firstSurname'); }
  get secondSurname() { return this.form.get('secondSurname'); }
  get nationality() { return this.form.get('nationality'); }
  get documentType() { return this.form.get('documentType'); }
  get documentTypeExt() { return this.form.get('documentTypeExt'); }
  get documentNumber() { return this.form.get('documentNumber'); }
  get documentNumberExt() { return this.form.get('documentNumberExt'); }
  get phone() { return this.form.get('phone'); }
  get email() { return this.form.get('email'); }
  get role() { return this.form.get('role'); }
  get companyname() { return this.form.get('companyname'); }
  get charge() { return this.form.get('charge'); }
  get birthDate() { return this.form.get('birthDate'); }

  request: RequestModel;
  signature: SignatureUsersModel;
  codeSaved: string;
  lstCountries: CountryModel[];
  selectedCountry: CountryModel
  IdNationality: any;
  public lstDocTypes: DocumentTypeModel[];
  constructor(
    private readonly requestService: RequestService,
    breakpointObserver: BreakpointObserver,
    private readonly crmGeoService: crmGeoService,
    public dialogRef: MatDialogRef<AgencySignaturesDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DataModal,
    private readonly translate: TranslateService,
    private readonly spinner: NgxSpinnerService) {
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });
    this.lstDocumentTypes = data.DocumentTypes;
    this.lstRolesArd = data.RolesArd
    this.lstCountries = data.Countries
    this.request = Object.assign({}, data.Request);
    this.signature = new SignatureUsersModel();
    if (data.Signature != null) {
      this.signature = Object.assign({}, data.Signature);
      this.searchCountry()
      this.IdNationality = this.signature.IdNationality
      

    }
  }

  async ngOnInit() {
    if (this.IdNationality != undefined) {
      this.selectDocType(this.IdNationality, 0)
    }
  }

  async clearControls() {
    this.firstName.setValue(null);
    this.middleName.setValue(null);
    this.firstSurname.setValue(null);
    this.secondSurname.setValue(null);
    this.documentType.setValue(null);
    this.documentNumber.setValue(null);
    this.phone.setValue(null);
    this.email.setValue(null);
    this.role.setValue(null);
    this.selectedCountry = null;
  }
  updateSignature() {

    if (this.request.SignatureUsers == null)
      this.request.SignatureUsers = []
    let index = this.request.SignatureUsers.findIndex(x => x.Id == this.signature.Id)
    if (index > -1) {
      this.request.SignatureUsers[index] = this.signature
    }
    else
      this.request.SignatureUsers.push(this.signature)

  }
  searchCountry() {
    this.lstCountries.forEach(c => {
      c.DocumentType.forEach(d => {
        if (d.Id == Number(this.signature.DocumentType)) {
          this.selectedCountry = c;
        }
      })
    });
  }
  async onSubmit(): Promise<void> {
    this.spinner.show();
    this.signature.IdRequest = this.request.Id
    this.signature.IdNationality = this.IdNationality
    let res: ResponseData;
    await this.requestService.postSignatureUser(this.signature).then(resp => {
      res = resp;
    })
    this.spinner.hide();
    let IdRequest;
    if (res.head.status.toLowerCase() == 'true') {
      let json = JSON.parse(res.body.response);
      IdRequest = json.Id;
      await Swal.fire({
        icon: 'success',
        text: this.translate.instant('Request.Messages.Success'),
        showConfirmButton: false,
        timer: 2000
      })
      this.dialogRef.close(this.request.Id);
    }
    else {
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      })
    }
  }

  async selectDocType(evt, opc) {
    if (opc == 1) {
      this.signature.BirthDate = undefined;
    }
    let countryOther = environment.request.countryOthers
    let countryColombia = environment.request.countryColombia
    if(this.lstDocTypes == undefined || this.lstDocTypes.length == 0)
      this.loadDocTypes(countryOther)
    if (evt.Code == countryColombia) {
      this.extCountryBool = false
      this.documentType.enable()
      this.documentTypeExt.disable()
      this.documentNumber.enable()
      this.documentNumberExt.disable()
      this.birthDate.disable()
    }
    else {
      if (this.IdNationality == environment.request.countryUnitedStates ||
        this.IdNationality == environment.request.countryUnitedKingdom ||
        this.IdNationality == environment.request.countryIsrael ||
        this.IdNationality == environment.request.countryGermany) {
        this.extCountryBool = true;
        this.documentType.disable()
        this.documentTypeExt.enable()
        this.documentNumber.disable()
        this.documentNumberExt.enable()
        this.birthDate.enable()
      } else {
        this.extCountryBool = false;
        this.documentType.enable()
        this.documentTypeExt.disable()
        this.documentNumber.enable()
        this.documentNumberExt.disable()
        this.birthDate.disable()
      }
    }
  }

  async selectDocTypeInput(evt, opc, event) {
    if(event.isUserInput){
      this.signature.IdNationality = evt.Code
      this.signature.NationalityName = evt.Name
      if (opc == 1) {
        this.signature.BirthDate = undefined;
      }
      let countryOther = environment.request.countryOthers
      let countryColombia = environment.request.countryColombia
      this.loadDocTypes(countryOther)
      if (evt.Code == countryColombia) {
        this.extCountryBool = false
        this.documentType.enable()
        this.documentTypeExt.disable()
        this.documentNumber.enable()
        this.documentNumberExt.disable()
        this.birthDate.disable()
      }
      else {
        if (evt.Code == environment.request.countryUnitedStates ||
          evt.Code == environment.request.countryUnitedKingdom ||
          evt.Code == environment.request.countryIsrael ||
          evt.Code == environment.request.countryGermany) {
          this.extCountryBool = true;
          this.documentType.disable()
          this.documentTypeExt.enable()
          this.documentNumber.disable()
          this.documentNumberExt.enable()
          this.birthDate.enable()
        } else {
          this.extCountryBool = false;
          this.documentType.enable()
          this.documentTypeExt.disable()
          this.documentNumber.enable()
          this.documentNumberExt.disable()
          this.birthDate.disable()
        }
      }
    }
  }

  async loadDocTypes(country) {
    await this.crmGeoService.getDocumentTypesCrm(country).then(res => {
      this.lstDocTypes = res;
    });
  }

  async DocTypeSelected(event,evt) {
    if(event.isUserInput)
      this.signature.DocumentName = evt.Description
  }

}
